// extracted by mini-css-extract-plugin
module.exports = {"container":"SocialLinks_container__3YmpS","items":"SocialLinks_items__2b4Fl"};